import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports : [RouterLink],
})
export class ModalComponent {
  modalRef = inject<MdbModalRef<ModalComponent>>(MdbModalRef);
  private identityService = inject(IdentityService);

  
 

  
  logout() {
    this.identityService.logout(true);
  }
}
